export * from './NCWPartnerDetails';
